import React from "react"
import { Navigate } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import Roles from "pages/Roles/Roles"
import Users from "pages/Users/Users"
// import Customers from "pages/Customers/Customers"
import Timeline from "pages/Timeline"
import JobApplication from "pages/JobApplication"
import JobApplicationDetails from "pages/JobApplication/JobApplicationDetails"
import InterviewSchedule from "pages/InterviewSchedule"
import CreateInterviewSchedule from "pages/InterviewSchedule/CreateInterviewSchedule"
import MyInterviews from "pages/MyInterviews"
// import Interviews from "pages/Interviews"
import TheoreticalTraining from "pages/TheoreticalTraining"
import Participants from "pages/TheoreticalTraining/Participants"
import PracticalTraining from "pages/PracticalTraining"
import PracticalTrainingParticipants from "pages/PracticalTraining/PracticalTrainingParticipants"
import CandidateTheoreticalTraining from "pages/Candidates/CandidatesTheoreticalTraining/CandidateTheoreticalTraining"
import CreateUser from "pages/Users/CreateUser"
import TermsConditions from "pages/TermsConditions"
import VerifyAndLogin from "pages/Authentication/VerifyAndLogin"
import AddEditRole from "pages/Roles/components/AddEditRole"
import Candidates from "pages/InterviewSchedule/Candidates/Candidates"
import TrainingMaterials from "pages/TrainingMaterials/TrainingMaterial"
import CreateTrainingMaterial from "pages/TrainingMaterials/CreateTrainingMaterial"
import UnAuthorized from "pages/UnAuthorized"
import InterViewStart from "pages/InterviewSchedule/InterviewsTabs/StartAssessment"
import ViewAssessment from "pages/InterviewSchedule/InterviewsTabs/ViewAssessment"
import CreatePracticalTraining from "pages/PracticalTraining/CreatePracticalTraining"
import CandidatePracticleTraining from "pages/Candidates/CandidatesPracticleTraining/CandidatePracticleTraining"
import CreateTheoreticalTraining from "pages/TheoreticalTraining/CreateTheoreticalTraining"
import Reports from "pages/Reports"
import TrialPeriod from "pages/TrialPeriod/TrialPeriod"
import TrialOperationCandidates from "pages/TrialPeriod/Candidates/Candidates"
import CreateTrialOperation from "pages/TrialPeriod/CreateTrialPeriod"
import CandidateTrialOperations from "../pages/Candidates/CandidatesTrailOperations/CandidateTrialOperations"
import Catering from "pages/Catering"
import IdCards from "pages/IdCards"
import Contracts from "pages/Contracts"
import CandidatesContract from "pages/Candidates/CandiatesContract"
import ContractParticipants from "pages/Contracts/component/ContractParticipants"
import TrainingPromotionSuggestions from "pages/PracticalTraining/TrainingPromotionSuggestions"
import RoasterManagement from "pages/RoasterManagement/RoasterManagement"
import BatchIDCards from "../pages/IdCards/component/BatchIDCards"

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },

  // Profile
  { path: "/profile", component: <UserProfile /> },
  // CANDIDATE
  { path: "/time-line", component: <Timeline /> },
  { path: "/my-interviews", component: <MyInterviews /> },
  {
    path: "/candidate-theoretical-training",
    component: <CandidateTheoreticalTraining />,
  },
  {
    path: "/candidate-practical-training",
    component: <CandidatePracticleTraining />,
  },
  {
    path: "/candidate-trial-operations",
    component: <CandidateTrialOperations />,
  },
  {
    path: "/candidate-contracts",
    component: <CandidatesContract />,
  },
  // Roles
  // { path: "/roles", component: <Roles /> },

  // { path: "/customers", component: <Customers /> },

  { path: "/applications", component: <JobApplication /> },
  { path: "/application-details", component: <JobApplicationDetails /> },

  //
  { path: "/interview-appointments", component: <InterviewSchedule /> },
  {
    path: "/interview-appointments/create",
    component: <CreateInterviewSchedule mode="create" />,
  },
  {
    path: "/interview-appointments/update",
    component: <CreateInterviewSchedule mode="update" />,
  },
  {
    path: "/interview-appointments/:uuid/candidates",
    component: <Candidates />,
  },
  {
    path: "/interview-appointments/start-assessment",
    component: <InterViewStart />,
  },
  {
    path: "/interview-appointments/view-assessment",
    component: <ViewAssessment />,
  },

  // Trial Period
  { path: "/trial-operation", component: <TrialPeriod /> },
  {
    path: "/trial-operation/:uuid/candidates",
    component: <TrialOperationCandidates />,
  },
  {
    path: "/trial-operation/create",
    component: <CreateTrialOperation mode="add" />,
  },
  {
    path: "/trial-operation/update",
    component: <CreateTrialOperation mode="update" />,
  },

  // { path: "/interviews", component: <Interviews /> },

  // Theoretical Training
  { path: "/theoretical-training", component: <TheoreticalTraining /> },
  { path: "/theoretical-training/participants", component: <Participants /> },
  {
    path: "/theoretical-training/create",
    component: <CreateTheoreticalTraining mode="add" />,
  },
  {
    path: "/theoretical-training/update",
    component: <CreateTheoreticalTraining mode="update" />,
  },

  // Practical Training
  { path: "/practical-training", component: <PracticalTraining /> },
  {
    path: "/practical-training/participants",
    component: <PracticalTrainingParticipants />,
  },
  {
    path: "/practical-training/promotion-suggestions",
    component: <TrainingPromotionSuggestions />,
  },
  {
    path: "/practical-training/create",
    component: <CreatePracticalTraining mode="add" />,
  },
  {
    path: "/practical-training/update",
    component: <CreatePracticalTraining mode="update" />,
  },

  // USERS/STAFF
  {
    path: "/users",
    component: <Users />,
  },
  {
    path: "/users/create",
    component: <CreateUser mode="add" />,
  },
  {
    path: "/users/update",
    component: <CreateUser mode="update" />,
  },

  // TRAINING MATERIALS
  {
    path: "/training-materials",
    component: <TrainingMaterials />,
  },
  {
    path: "/training-materials/create",
    component: <CreateTrainingMaterial mode="add" />,
  },
  {
    path: "/trainingMaterials/update",
    component: <CreateTrainingMaterial mode="update" />,
  },

  {
    path: "/",
    exact: true,
    component: <Navigate to="/profile" />,
  },

  //Roles
  {
    path: "/roles-and-permissions",
    component: <Roles />,
  },
  {
    path: "/roles-and-permissions/create",
    component: <AddEditRole mode="add" />,
  },
  {
    path: "/roles-and-permissions/update",
    component: <AddEditRole mode="update" />,
  },
  {
    path: "/roles-and-permissions/view",
    component: <AddEditRole mode="view" />,
  },

  {
    path: "/unauthorized",
    component: <UnAuthorized />,
  },

  //Reports
  {
    path: "/export-operations",
    component: <Reports />,
  },
  //Catering
  {
    path: "/catering",
    component: <Catering />,
  },
  //Id Cards
  {
    path: "/id-cards",
    component: <IdCards />,
  },
  {
    path: "/id-cards/:uuid/id-cards-list",
    component: <BatchIDCards />,
  },
  //Contracts
  {
    path: "/contracts",
    component: <Contracts />,
  },
  {
    path: "/contracts/participants",
    component: <ContractParticipants />,
  },
  //Roaster management
  {
    path: "/roaster-management",
    component: <RoasterManagement />,
  },
]

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/verify-and-login", component: <VerifyAndLogin /> },
  { path: "/terms-conditions", component: <TermsConditions /> },
]

export { authProtectedRoutes, publicRoutes }
